// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SeEgSluXDKmWdVdr_Tfx{top:-2px}", "",{"version":3,"sources":["webpack://./src/templates/lessonOverview/resource-list.module.scss"],"names":[],"mappings":"AAAA,sBACE,QAAA","sourcesContent":[".dropdownButton {\n  top: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownButton": "SeEgSluXDKmWdVdr_Tfx"
};
export default ___CSS_LOADER_EXPORT___;
